/* eslint-disable @typescript-eslint/no-floating-promises */

import { fetchDeepLink } from '@services/fetchDeepLink'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import {
  CHALLAN_LOADER_SCREEN_TEXTS,
  NO_CHALLAN,
  PENDING_CHALLAN,
} from '@components/MainWidget/ChallanWidget/challanConstants'
import { fetchWidgetProductFn } from '@configs/segmentEvents.config'
import { commonWidgetConfig } from './commonWidgetConfig'
import { SEGMENT } from './widgetSegments'
import { PUC_DETAIL, WIDGET_STATUS_FALLBACK, CHALLAN_WIDGET } from './commonConstants'
import { ChallanStatus } from '../ChallanWidget/challanStatus'

export const validatePUC = ({ pucData, setIsPucExpired }) => {
  // extract today pucdata and match with puc date
  const today = new Date()
  // Get the year, month, and day
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0') // Months are 0-based
  const day = String(today.getDate()).padStart(2, '0')
  // Format the date as YYYY-MM-DD
  const formattedDate = `${year}-${month}-${day}`
  formattedDate <= pucData?.expiry_date ? setIsPucExpired(true) : setIsPucExpired(false)
}

const vehicleTypeMap = {
  PRIVATE_CAR: 'Car',
  TWO_WHEELER: 'Bike',
}

const vehicleType = vehicleData => vehicleTypeMap?.[vehicleData?.vehicle_type_v2] || 'N/A'

interface OnDownloadAppParams {
  regNo: string
  segmentEventCommonProperties?: object
  widgetType?: string
  phone?: string
  userData?: object
  vehicleData?: Record<string, any> | null
  isPucWidget?: boolean
  pucStatus?: boolean
  isChallanWidget?: boolean
  challanAmount?: number
  providerData?: object
  ctaText?: string
}

export const onDownloadApp = async ({
  regNo,
  segmentEventCommonProperties,
  widgetType = CHALLAN_WIDGET,
  phone,
  vehicleData,
  isPucWidget = WIDGET_STATUS_FALLBACK.IS_PUC_WIDGET,
  pucStatus = WIDGET_STATUS_FALLBACK.IS_PUC_STATUS,
  isChallanWidget = WIDGET_STATUS_FALLBACK.IS_CHALLAN_WIDGET,
  challanAmount = WIDGET_STATUS_FALLBACK.CHALLAN_AMOUNT,
  providerData,
  ctaText,
}: OnDownloadAppParams) => {
  let url = commonWidgetConfig.default_deep_link[widgetType]
  const deepLink = await fetchDeepLink({ regNo, widgetType, mobileNo: phone, selectedProvider: providerData, ctaText })
  if (deepLink) url = deepLink

  const trackEventProperties = {
    ...segmentEventCommonProperties,
    product: commonWidgetConfig.product[widgetType] || fetchWidgetProductFn[widgetType]?.(),
    phone,
    registration_number: regNo,
    vehicle_type: vehicleType(vehicleData),
    cta_text: ctaText,
  }

  if (isPucWidget) {
    trackEventProperties.state_name = pucStatus ? PUC_DETAIL.isActive : PUC_DETAIL.isExpired
  }
  if (isChallanWidget) {
    trackEventProperties.state_name = challanAmount ? PENDING_CHALLAN : NO_CHALLAN
  }
  trackEvent(SEGMENT.TAB_BTN_ACKO, trackEventProperties)
  if (window) {
    window.location.href = url
  }
}

export const getTotalUnpaidAmountChallan = challanApiResponseData => {
  const unpaidChallans: any = challanApiResponseData?.filter(
    (challan: any) => challan?.challan_status === ChallanStatus.Unpaid
  )

  if (unpaidChallans.length > 0) {
    const totalUnpaidAmount = unpaidChallans?.reduce((sum, challan) => sum + parseFloat(challan?.amount?.total), 0)

    return totalUnpaidAmount.toString()
  }

  return null
}

export const getUnpaidChallan = challanApiResponseData => {
  const unpaidChallans: any = challanApiResponseData?.filter(
    (challan: any) => challan?.challan_status === ChallanStatus.Unpaid
  )
  return unpaidChallans.length
}

export const checkRTODetails = (regNo, RTODetailsData, setRtoDetailIndex) => {
  const regPrefix = regNo?.substring(0, 4).toUpperCase().replace('-', '') // Extracting the prefix and removing hyphen
  const matchingRTOIndex = RTODetailsData.findIndex(rto => rto?.Number?.replace('-', '').toUpperCase() === regPrefix)
  setRtoDetailIndex(matchingRTOIndex !== -1 ? matchingRTOIndex : 0)
}

export const handleLoaderUpdate = (currentLoaderIndex, setCurrentLoaderIndex, onComplete) => {
  if (currentLoaderIndex < CHALLAN_LOADER_SCREEN_TEXTS.length - 1) {
    const timer = setTimeout(() => {
      setCurrentLoaderIndex(prevIndex => prevIndex + 1)
    }, 1000)

    return () => clearTimeout(timer)
  } else {
    const timer = setTimeout(() => {
      onComplete()
    }, 1000)
    return () => clearTimeout(timer)
  }
}
